import SectionHeading from "./SectionHeading";
import { tipGroups } from "@/mocks/mayiBaoliao";

export default function Checklist() {
  return (
    <section id="checklist" className="w-full bg-background-100/60">
      <div className="mx-auto w-full max-w-6xl px-4 py-14 md:px-6 md:py-20">
        <SectionHeading
          over="Field Notes · 避坑清单"
          title="把雷区列在前面，出发前过一遍"
          desc="由往期实况归纳成的高频注意事项，核对后再出门，能省去大半临时烦恼。"
        />

        <div className="mt-9 grid grid-cols-1 gap-3 md:grid-cols-3 md:gap-4">
          {tipGroups.map((g) => (
            <div
              key={g.title}
              className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-5 md:p-6"
            >
              <div className="flex items-center gap-3">
                <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-100">
                  <i className={`${g.iconClass} text-xl text-accent-700`} />
                </span>
                <h3 className="font-heading text-lg font-bold text-foreground-950">{g.title}</h3>
              </div>
              <ul className="mt-5 space-y-3">
                {g.tips.map((t) => (
                  <li key={t} className="flex items-start gap-2.5 text-sm leading-relaxed text-foreground-700">
                    <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center">
                      <i className="ri-checkbox-circle-line text-base text-secondary-500" />
                    </span>
                    <span>{t}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}